import Util from '@/utils/util'
import Axs from '@/utils/axs'
import {defineStore} from 'pinia'
import storeInfoFun from '@/info.js'
import storeCommunitysFun from '@/home/zhsq2/communitys/store.js'
import storeMerchantsFun from '@/home/zhsq/merchants/store.js'
import storePropertyCompanyFun from '@/home/zhsq3/propertyCompany/store.js'

let storeFunc = defineStore("sysMng",{
    state:()=>{
        return {
           //业务数据  count:99
           openedfunsViewArr:[],
           tabSelected:"",
           funsLayout:"",
           funsLayoutTitle:"",
        funsLayoutSearchs:null,
           treeData:null,
           userData:null,
           bindStaff:null,
           authority:null,
           mails:null,
           waterMarkData:null,
           waterMarkViewData:null,
           newsViewedCount:0,
           guideViewedCount:0,
           approves:[],
           approvesDone:[],
           approvesAll:[],
           community:null,
           merchant:null,
           ComfirEnum: [{
                id: 0,
                label: "否"
            },
            {
                id: 1,
                label: "是"
            }],
            IdentityTypeEnum: [{
                id: 1,
                label: "身份证"
            },
            {
                id: 2,
                label: "护照"
            },
            {
                id: 3,
                label: "港澳台通行证"
            }],
            SexEnum:[
                {
                    id: 0,
                    label: "未输入"
                },
                {
                    id: 1,
                    label: "男"
                },
                {
                    id: 2,
                    label: "女"
                },
            ],
        }
    },
    actions:{
        async loginData(data)
        {
            this.userData = data.userData
            this.bindStaff = data.bindStaff
            this.mails = data.mails
            this.approves = data.approves
            this.approvesDone = data.approvesDone
            this.approvesDone.sort((a,b)=>{ return b.enable - a.enable })
            this.approvesAll = [...this.approves,...this.approvesDone]
            this.approvesAll.sort((a,b)=>{ return b.enable - a.enable })
            this.authority = data.authority
            this.waterMarkData = data.waterMarkData
            this.newsViewedCount = data.newsViewedCount
            this.guideViewedCount = data.guideViewedCount
            this.waterMarkViewData = this.setWaterMarkViewData(this.waterMarkData);
            let storeCommunitys = storeCommunitysFun();
            this.community = await storeCommunitys.loadDataByIDAsync(data.userData.communityId);
            let storeMerchants = storeMerchantsFun();
            this.merchant = await storeMerchants.loadDataByIDAsync(data.userData.merchantId);
            let storePropertyCompany = storePropertyCompanyFun();
            this.propertyCompany = await storePropertyCompany.loadDataByIDAsync(data.userData.propertyCompanyId);

            

        },
        setWaterMarkViewData(waterMarkData)
        {
            let waterMarkViewData = {
                content: waterMarkData.content,
                image:this.getImageUrl(waterMarkData.imageUrl),
                font: {
                    fontSize: waterMarkData.fontSize,
                    color: waterMarkData.fontColor,
                    fontWeight: waterMarkData.fontWeight,
                    fontFamily:waterMarkData.fontFamily,
                    fontStyle: waterMarkData.fontStyle,
                    textAlign: waterMarkData.textAlign,
                    textBaseline: waterMarkData.textBaseline,
                },
                zIndex: waterMarkData.zIndex,
                rotate: waterMarkData.rotate,
                gap: [waterMarkData.gap_vh, waterMarkData.gap_vm],
                offset: [waterMarkData.offset_vh, waterMarkData.offset_vm],
                width:waterMarkData.width,
                height:waterMarkData.height,
            }
            return waterMarkViewData
        },

        getImageUrl(imageUrl)
        {
           let storeInfo = storeInfoFun();
            if(Util.isEmpty(imageUrl))
                return undefined
            let timestamp = new Date().getTime();
           let url = storeInfo.linkMinIOUrl +  imageUrl + "?timestamp=" + timestamp
          // console.log("logo路径===》",url)
           return url;
        },

        getAuthorityMenuDisable(mainmenu)
        {
            //console.log("QQQQQQQQQQQQQgetAuthorityMenuDisable mainmenu=>",mainmenu)
            mainmenu += ""
            if(Util.isEmpty(this.authority))
            {
                return false;
            }
          //  console.log("刷一次===>",this.authority.disableMainMenu)
            let disable = false;
            let disableMainMenu = this.authority.disableMainMenu.split(" ");
            disableMainMenu.forEach(element => {
                if(element == mainmenu)
                {
                    disable = true;
                }
            });
            return disable
        },

        getAuthorityFuncDisable(funId)
        {
            if(Util.isEmpty(this.authority))
            {
                return false;
            }
            let ref = false
            let disableFunctionsArr = this.authority.disableFunctions.split(" ");
            disableFunctionsArr.forEach(element => {
                if(element == funId)
                {
                    ref = true;
                }
            });
            return ref;
        },

        getAuthorityFuncReadEnable(funId)
        {
            if(Util.isEmpty(this.authority))
            {
                return false;
            }
            let ref = false
            let readEnableFunctions = this.authority.readEnableFunctions.split(" ");
            readEnableFunctions.forEach(element => {
                if(element == funId)
                {
                    ref = true;
                }
            });
            return ref;
        },

        getAuthorityFuncAddEnable(funId)
        {
            if(Util.isEmpty(this.authority))
            {
                return false;
            }
            let ref = false
            let addEnableFunctions = this.authority.addEnableFunctions.split(" ");
            addEnableFunctions.forEach(element => {
                if(element == funId)
                {
                    ref = true;
                }
            });
            return ref;
        },

        getAuthorityFuncEditEnable(funId)
        {
            if(Util.isEmpty(this.authority))
            {
                return false;
            }
            let ref = false
            let editEnableFunctions = this.authority.editEnableFunctions.split(" ");
            editEnableFunctions.forEach(element => {
                if(element == funId)
                {
                    ref = true;
                }
            });
            return ref;
        },

        getAuthorityFuncDeletEnable(funId)
        {
            if(Util.isEmpty(this.authority))
            {
                return false;
            }
            let ref = false
            let deleteEnableFunctions = this.authority.deleteEnableFunctions.split(" ");
            deleteEnableFunctions.forEach(element => {
                if(element == funId)
                {
                    ref = true;
                }
            });
            return ref;
        },


        getAuthorityFuncStruct(funId)
        {
            let ref = {
                disable:0,
                readEnable:0,
                addEnable:0,
                editEnable:0,
                deleteEnable:0,
            }

            if(Util.isEmpty(this.authority))
            {
                return ref;
            }
           // console.log(funId + "===this.authority======>",this.authority)
            let disableFunctionsArr = []
            if(!Util.isEmpty(this.authority.disableFunctions))
                disableFunctionsArr = this.authority.disableFunctions.split(" ");
          
            disableFunctionsArr.forEach(element => {
                if(Util.isEmpty(element))
                    return;
                if(element == funId)
                {
                    ref.disable = 1;
                }
            });
            
            let readEnableFunctions = []
            if(!Util.isEmpty(this.authority.readEnableFunctions))
                readEnableFunctions = this.authority.readEnableFunctions.split(" ");
            readEnableFunctions.forEach(element => {
                if(Util.isEmpty(element))
                    return;
                if(element == funId)
                {
                    ref.readEnable = 1;
                }
            });

            let addEnableFunctions = []
            if(!Util.isEmpty(this.authority.addEnableFunctions))
                addEnableFunctions = this.authority.addEnableFunctions.split(" ");
            addEnableFunctions.forEach(element => {
                if(Util.isEmpty(element))
                    return;
                if(element == funId)
                {
                    ref.addEnable = 1;
                }
            });
           // console.log("??????????????this.authority.editEnableFunctions" + this.authority.editEnableFunctions + "+++++++++++++")
            let editEnableFunctions = []
            if(!Util.isEmpty(this.authority.editEnableFunctions))
                editEnableFunctions = this.authority.editEnableFunctions.split(" ");
           
            editEnableFunctions.forEach(element => {
                if(Util.isEmpty(element))
                    return;
                if(element == funId)
                {
                    ref.editEnable = 1;
                }
            });
            
            let deleteEnableFunctions = []
            if(!Util.isEmpty(this.authority.deleteEnableFunctions))
                deleteEnableFunctions = this.authority.deleteEnableFunctions.split(" ");
            deleteEnableFunctions.forEach(element => {
                if(Util.isEmpty(element))
                    return;
                if(element == funId)
                {
                    ref.deleteEnable = 1;
                }
            });
           
            return ref;
        },

        controlTableEnableByAuthority(data,funcId)
        {
            let funcStruct = this.getAuthorityFuncStruct(funcId);
           // console.log(funcId + " ???????????????funcStruct=>",funcStruct)
            data.hideDetails = false;
            if(!Util.isEmpty(data.tableAdd))
                data.tableAdd.hide = false;
            if(!Util.isEmpty(data.tableEdit))
                data.tableEdit.hide = false;
            if(!Util.isEmpty(data.tableDelete))
                data.tableDelete.hide = false;
            if(!Util.isEmpty(data.tableAddGrp))
                data.tableAddGrp.hide = false;
            
            if(funcStruct.disable == 1)
            {
                data.hideDetails = true;
                if(!Util.isEmpty(data.tableAdd))
                    data.tableAdd.hide = true;
                if(!Util.isEmpty(data.tableEdit))
                    data.tableEdit.hide = true;
                if(!Util.isEmpty(data.tableDelete))
                    data.tableDelete.hide = true;
                if(!Util.isEmpty(data.tableAddGrp))
                    data.tableAddGrp.hide = true;
                if((Util.isEmpty(data.tableEdit) || data.tableEdit.hide) && (Util.isEmpty(data.deleteEnabl) || data.deleteEnabl.hide))
                {
                    if(data.decrtControl ==undefined)
                        data.decrtControl = {}
                    data.decrtControl.showOperator = false
                }
                    return;
            }
            else if(funcStruct.readEnable == 1 || funcStruct.addEnable == 1 || funcStruct.editEnable == 1|| funcStruct.deleteEnabl == 1)
            {
                data.hideDetails = funcStruct.readEnable == 1? false :true;
                if(!Util.isEmpty(data.tableAdd))
                    data.tableAdd.hide =  funcStruct.addEnable == 1? false :true;

                if(!Util.isEmpty(data.tableAddGrp))
                    data.tableAddGrp.hide = funcStruct.addEnable == 1? false :true;

                if(!Util.isEmpty(data.tableEdit))
                    data.tableEdit.hide =  funcStruct.editEnable == 1? false :true;
                if(!Util.isEmpty(data.tableDelete))
                    data.tableDelete.hide =  funcStruct.deleteEnabl == 1? false :true;
            }
            if((Util.isEmpty(data.tableEdit) || data.tableEdit.hide) && (Util.isEmpty(data.deleteEnabl) || data.deleteEnabl.hide))
            {
                if(data.decrtControl ==undefined)
                    data.decrtControl = {}
                data.decrtControl.showOperator = false
            }

        },

        clear()
        {
           // console.log("openedfunsViewArr清理了3333333333333?????????????")
            this.openedfunsViewArr =[];
            this.tabSelected="";
            this.funsLayout ="";
            this.funsLayoutTitle="",
            this.funsLayoutSearchs = null;
            this.treeData =null;
            this.userData =null;
            this.authority =null;
            this.community = null;
        }

    },
    getters:{
        //计算属性，只读属性
        
    },
    persist: true
})

 //组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc